import VideoTemplate from '../../../component/template/VideoTemplate.js'
import Webview from "../../../component/native/visible/Webview";
import PlayerView from "../../../component/native/visible/PlayerView";
import App from "../../../App";
import {getFilePathByRemoteUrl} from '@src/common/util'
import Dialog from "../../../component/visible/Dialog"
import SimpleBanner from "../../../component/visible/SimpleBanner"
import Message from '../../../../class/Message'

export default class SingleVideoDemo extends VideoTemplate {
    constructor(...props) {
        super(...props)
    }


    initComponents() {
        super.initComponents()

        this.miniEndCard = new Webview()
        this.endCard = new Webview()

        //this.container.append(this.endCard)
        this.endCard.hide()
        this.endCard.insertBelowTo(this.playerView)


        //let miniEndCardTemplateUrl = 'http://192.168.1.124:3000/miniEndCardDemo/miniEndCardDemo.html'
        let miniEndCardTemplateUrl = this.campaign && this.campaign.rv && this.campaign.rv.paused_url
        Webview.getLoadCampaignParams(miniEndCardTemplateUrl, [this.campaign], this.unit.id, this.unit.setting)
            .then(loadParams => {
                //console.log('哈哈哈哈11', this.campaign, this.unit.id,miniEndCardTemplateUrl,loadParams)
                this.miniEndCard.hide()
                this.miniEndCard.load(loadParams)
            })


        //let endCardTemplateUrl = 'http://192.168.1.124:3000/endCardDemo/endCardDemo.html'
        let endCardTemplateUrl = this.campaign && this.campaign.endcard_url
        Webview.getLoadCampaignParams(endCardTemplateUrl, [this.campaign], this.unit.id, this.unit.setting)
            .then(loadParams => {
                this.endCard.load(loadParams)
            })

        let banner = new SimpleBanner({
            icon: this.campaign.icon_url,
            buttonText :this.campaign.ctatext,
            title: this.campaign.title,
            desc: this.campaign.desc,
            star: this.campaign.rating,
            rating: this.campaign.rating,
            onClick: e => {
                console.log('banner 被点击')
            },
            onIconClick: e => {
                console.log('banner-icon 被点击')
            },
            onButtonClick: e => {
                console.log('banner-btn 被点击')
            },
        })
        this.dialog = new Dialog({
            title: 'dialog',
            wrapClassName: 'test-wrap',
            titleClassName: 'test-title',
            contentClassName: 'test-content',
            content: banner,
            titleTools: [{
                type: 'flatClose',
                onClose: () => {
                    console.log('banner 关闭按钮被点击')
                }
            }]
        })
        document.querySelector('#dialog-test').addEventListener('click', () => {

            this.dialog.show()
        }, false)

        document.querySelector('#app').querySelector('#close-test').addEventListener('click', () => {
            const sendData = {
                instanceId: App.rootWebviewId,
                campaign: this.campaign,
                currentTime: this.currentTime++,
            }
            Message.emitMessageToSuperView('onCloseBtnClick', sendData)
        }, false)
        document.querySelector('#app').querySelector('#onvideochange-test').addEventListener('click', () => {
            const sendData = {
                instanceId: App.rootWebviewId,
                campaign: this.campaign,
                currentTime: this.currentTime++,
            }
            Message.emitMessageToSuperView('onVideoCurrentTimeChange', sendData)
        }, false)
        document.querySelector('#app').querySelector('#install-test').addEventListener('click', () => {
            const sendData = {
                instanceId: App.rootWebviewId,
                campaign: this.campaign,
                currentTime: this.currentTime++,
            }
            Message.emitMessageToSuperView('onInstallBtnClick', sendData)
        }, false)
        document.querySelector('#app').querySelector('#videoend-test').addEventListener('click', () => {
            const sendData = {
                instanceId: App.rootWebviewId,
                campaign: this.campaign,
                currentTime: this.currentTime++,
            }
            Message.emitMessageToSuperView('onVideoEnded', sendData)
        }, false)
    }

    adShowed() {
        super.adShowed()
        // this.playerView.play()
    }

    bindPageEvent() {
        super.bindPageEvent()
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
        this.playerView.onAppend(event => {
            console.log('playerView onAppend', event)
        })
        this.playerView.onAppendTo(event => {
            console.log('playerView onAppendTo', event)
        })
        //this.playerView.play()
        this.playerView.onClicked(event => {
            console.log('playerView onClicked', this.playerView.isPlaying(), this.playerView.isPaused())
            if (this.playerView.isPlaying()) {
                this.playerView.pause()
                    .then(() => {
                        this.miniEndCard.show()
                        this.miniEndCard.fireJsEvent('testEvent', {data: 'hi event'})
                    })


            } else {
                this.playerView.play()
                setTimeout(() => {
                    this.playerView.play()
                }, 10)
            }
        })


        //this.playerView.play()
        this.playerView.onFinish(event => {
            console.warn('playerView.onFinish::', this.playerView)
            //this.container.append(this.endCard)
            this.endCard.toFront()
            this.endCard.show()
        })

        this.playerView.onCloseBtnClicked(event => {
            this.playerView.stop().then(() => {
                console.log('视频已停止::')
                setTimeout(() => {
                    console.log('正在关闭广告::', event)
                    App.closeAd()
                }, 3e3)
            })
        })

        /*App.onBroadcast('miniEndCardClosed', ()=>{
            console.log('接收到miniendcard关闭广播')
            this.playerView.play()
        })*/
        App.onEmitMessage('miniEndCardClosed', event => {
            const {action} = event
            if (action === 'miniEndCardClosed') {
                console.log('miniEndCard发出postmessage::', this.miniEndCard)
                this.miniEndCard.postMessage({
                    action: 'close'
                })
                this.playerView.play()
            }
        })
    }

    initSlots() {
        super.initSlots()
        // this.slotIn('slot_video', this.miniEndCard)
        /*setTimeout(()=>{
            this.slotIn('slot_video', this.miniEndCard)
        },1e4)*/
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.endCard && this.endCard.destory()
        this.miniEndCard && this.miniEndCard.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        return Promise.all([
            super._isLoadFinish(),
            this.miniEndCard.whenCampaignReady(),
            this.endCard.whenCampaignReady()
        ])
    }
}